import { useAtom } from "jotai";
import { useEffect } from "react";
import { useDialog } from "../hooks/useDialog";
import { globalStickErrorStore } from "../stores/globalStickyError";

/*
    E' possibile richiamare questo sticky error anche fuori da react
    tramite l'observable globalStickyError$
*/
export function GlobalStickyError({ children }: Readonly<{ children?: React.ReactNode }>) {
  const MLDialog = useDialog();
  const [{ message }, setSticky] = useAtom(globalStickErrorStore);

  useEffect(() => {
    if (!message) return;
    MLDialog.showSnackbar(message, {
      variant: "error",
    });
    setSticky({ message: null });
  }, [message]);

  return <>{children}</>;
}
